<div fxLayout="column">
  <app-page-header (tabsChangeEvent)="changeTabs($event)"
                   [tabs]="tabs"
                   [isTabbed]="true"
                   [selectedTab]="getInitialTab()"
                   [section]="'Surveys'"
                   [title]="survey.name ?? 'Explore your surveys'"
                   [description]="'View and manage responses, questions and results for the survey.'">
  </app-page-header>

  <div class="page-content full-screen-height-page-default" fxLayout="column" fxLayoutGap="20px">
    @switch (dataPrefetchState) {
      @case ("loading") {
        <app-info-panel [message]="['Loading survey data...']"
                        [fullWidth]="true"
                        [type]="PanelType.INFO"
                        class="p-20">
        </app-info-panel>
      }
      @case ("complete") {

        @if (activeTab == 'survey_configuration') {
          <app-survey-form-builder [survey]="survey"
                                   (updatedSurvey)="onUpdatedSurvey($event)"
          ></app-survey-form-builder>
        }

        @if (activeTab == 'survey_submissions') {
          <app-survey-submissions-list [survey]="survey"></app-survey-submissions-list>
        }

        @if (activeTab == 'survey_results') {
          <app-survey-results [survey]="survey"></app-survey-results>
        }


      }
      @case ("error") {
        <app-info-panel [message]="[surveyServiceErrorMessage]"
                        [fullWidth]="true"
                        [type]="PanelType.ERROR"
                        [buttons]="true"
                        [buttonLabels]="['Reload page']"
                        (emitEvent)="ngOnInit()"
                        class="p-20">
        </app-info-panel>
      }
    }
  </div>
</div>
